import React, { useCallback } from 'react';
import logLevels from '../../../const/logLevels';
import getTextWidth from '../../../services/mini/getTextWidth';
import LogLine from './LogLine';

export default function LogLineWrapper(props) {
    var { index, style, logs, log, filterUpdateTs, onHover } = props;
    var key,
        maxLogLine = 1,
        maxScriptNameWidth = 0,
        hasAudioPreview = false,
        hasImagePreview = false;

    const fileNames = [];
    for (let i = 0; i < logs.length; i++) {
        maxLogLine = Math.max(maxLogLine, logs[i].line || 0);
        if (logs[i].file) {
            fileNames.push(logs[i].file);
        }

        if (logs[i].screenshotLink && !hasImagePreview) {
            hasImagePreview = true;
        }
        if (logs[i].intentAudioLink && !hasAudioPreview) {
            hasAudioPreview = true;
        }
    }

    const longestFileName = fileNames.reduce(function (aLog, bLog) {
        return aLog.length > bLog.length ? aLog : bLog;
    }, []);

    const hoverCb = useCallback(() => {
        if (onHover && log.new) {
            onHover({ log });
        }
    }, [log, onHover]);

    maxScriptNameWidth = getTextWidth(longestFileName + ':', "13px Lato");

    maxLogLine = (maxLogLine).toString().length;

    if (logs) {
        log = logs[index];

        key = log ?
            `err-${log.id || (index + '-' + log.ts)}-${maxLogLine}-${maxScriptNameWidth}-${filterUpdateTs}-${hasAudioPreview && 'with-audio'}-${hasImagePreview && 'with-image'}` :
            `err-${index}-${maxLogLine}-${maxScriptNameWidth}-${filterUpdateTs}-${hasAudioPreview && 'with-audio'}-${hasImagePreview && 'with-image'}`;
    }

    return <div key={`${key}`} data-index={index} style={style} onMouseOver={hoverCb} onClick={hoverCb}>
        {log && <LogLine log={log}
            key={`${key}`}
            isNew={log.new}
            maxLineLog={maxLogLine}
            maxScriptNameWidth={maxScriptNameWidth}
            hasAudioPreview={hasAudioPreview}
            hasImagePreview={hasImagePreview}
            logKey={`${key}-${log.new}`}
            {...props}
        />}
    </div>;
}